import loadSpecificCombatantImages from "../helpers/loadSpecificCombatantImages";
import store from "../store/index";
//-----------------------
// load combatant images
//-----------------------
export default function loadCombatantImages() {
  // console.log("--------------------------")
  // console.log("IN loadCombatantImages") 
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //----------------------
  // loop thru combatants
  //----------------------
  for (let i = 0; i < combatants.length; i++) {
    //-------------
    // images parm
    //-------------
    let parm = {
      idx: i,
      img: null,
    };
    //-----------------------
    // load combatant images
    //-----------------------
    loadSpecificCombatantImages(parm);
  }
}
